var place = [
  {
    id: 0,
    name: "COX'S BAZAR",
    shortDescription:
      "Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...",
    longDescription:
      "Cox’s Bazar is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts. South of town, the tropical rainforest of Himchari National Park has waterfalls and many birds. North, sea turtles breed on nearby Sonadia Island.",
    image: "https://i.ibb.co/DbcD9zC/Rectangle-1.png",
    map:
      "!1m18!1m12!1m3!1d59423.97233887795!2d91.96925362232153!3d21.42931294833106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30adc8635fc8795d%3A0xe9ecbaa1945340c3!2sSea%20Inn%20Beach%20Point!5e0!3m2!1sen!2sbd!4v1600444452502!5m2!1sen!2sbd",
  },

  {
    id: 1,
    name: "SREEMANGAL",
    shortDescription:
      "It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor...",
    longDescription:
      "It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor.[2] A copper plate of Raja Marundanath from the 11th century was found in Kalapur. During an excavation at Lamua, an ancient statue of Ananta Narayan was dug out. In 1454, the Nirmai Shiva Bari was built and still stands today.",
    image: "https://i.ibb.co/fQ6R057/Sreemongol.png",
    map:
      "!1m18!1m12!1m3!1d29087.56683274612!2d91.7075346719389!3d24.313523696130027!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x37517a7a9ac91745%3A0x50f827893a88c955!2sSreemangal!5e0!3m2!1sen!2sbd!4v1600267120491!5m2!1sen!2sbd",
  },
  {
    id: 2,
    name: "SUNDARBANS",
    shortDescription:
      "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal...",
    longDescription:
      "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh. It comprises closed and open mangrove forests, agriculturally used land, mudflats and barren land, and is intersected by multiple tidal streams and channels.",
    image: "https://i.ibb.co/PMgNMHR/sundorbon.png",
    map:
      "!1m18!1m12!1m3!1d946898.4171339684!2d88.72649432503009!3d22.01813247840655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a004caac2c7b315%3A0x4716abcfbb16c93c!2sSundarbans!5e0!3m2!1sen!2sbd!4v1600267229948!5m2!1sen!2sbd",
  },
];

export default place;
